// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalContainer_bXm9V {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--_00000020-background);
  justify-content: center;
  align-items: center;
  z-index: 5;
  transition: opacity 300ms ease-in-out;
  -webkit-transition: opacity 300ms ease-in-out;
  -moz-transition: opacity 300ms ease-in-out;
  -ms-transition: opacity 300ms ease-in-out;
  -o-transition: opacity 300ms ease-in-out;
}
.upgradePlanContainer_tPujG {
  background: var(--white-background);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  max-width: 780px;
  max-height: 90vh;
  transform: scale(1);
  animation: scaleUp_jx0lu 300ms ease-out forwards;
  overflow: hidden;
  @media (width<=768px) {
    max-width: 100vw;
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    -o-border-radius: 0;
  }
}

.scaleDown_SiOJT {
  animation: scaleDown_SiOJT 300ms ease-in forwards;
  -webkit-animation: scaleDown_SiOJT 300ms ease-in forwards;
}

@keyframes scaleUp_jx0lu {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

@keyframes scaleDown_SiOJT {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0);
  }
}

.fadeOut_lEtme {
  opacity: 0;
}

.upgradePlanHeader_mTnqa {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 64px;
  border-bottom: 1px solid var(--e3-border);
  background: var(--f5-background);
}
.headerLeft_Of7GH {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--_2-color);
  font-size: 20px;
  font-weight: 600;
  gap: 10px;
}
.closeIcon_IVDfF {
  display: flex;
  align-items: center;
  justify-content: center;  
  cursor: pointer;
  border-radius: 4px;
  background: var(--f6-background);
  -webkit-user-select: none;
          user-select: none;
  text-decoration: underline;
}
.upgradePlanTitle_PTgOD {
  font-size: 16px;
  font-weight: 700;
  color: var(--_2-color);
  margin: 0px;
}

.content_WUfDK {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  max-height: 100vh;
  flex-wrap: wrap;
  overflow: hidden;
  background: var(--f5-background);
  box-sizing: border-box;
  overflow-y: auto;
}

.leftContainer_dYRkJ {
  display: flex;
  flex-direction: column;
  gap: 0px;
  width: 60%;
  padding: 10px 14px;
  overflow-y: auto;
  border-radius: 10px;
  margin: 0px 8px 8px;
  background: var(--white-background);
  flex: 1.5 1;
  min-width: 400px;
  max-height: 70vh;
  overflow-y: scroll;
  h3 {
    margin: 10px 0px;
    font-size: 16px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.leftContainer_dYRkJ input::placeholder {
  color: var(--_75-color);
}

.leftContainer_dYRkJ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.titleWithIcon_zjcR8 {
  display: flex;
  align-items: center;
  gap: 20px;
}
.leftContainer_dYRkJ::-webkit-scrollbar-thumb {
  background-color: var(--e2-background);
  border-radius: 12px;
}
.leftContainer_dYRkJ::-webkit-scrollbar-track {
  background: transparent;
}


.rightContainer_JwaxT {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 40%;
  padding: 10px 12px;
  flex: 1 1;
  overflow-y: auto;
  min-width: 200px;
}
.rightContainer_JwaxT::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.rightContainer_JwaxT::-webkit-scrollbar-thumb {
  background-color: var(--e2-background);
  border-radius: 12px;
}
.rightContainer_JwaxT::-webkit-scrollbar-track {
  background: transparent;
}

.lightText_d6Dvg {
  color: var(--595959-color);
  line-height: 18px;
  max-width: 362px;
  font-size: 13px;
  font-weight: 400;
}

.paymentMethodsContainer_zvwNA {
  display: grid;
  align-items: flex-start;
  gap: 20px;
  flex-direction: column;
}
.paymentMethodsContainerGrid_RRAI6 {
  grid-template-columns: 1fr 1fr;
  > div:nth-child(1) {
    > div {
      display: flex;
    }
  }
}

.spacedBetween_gCdwa {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: var(--_2-color);
  font-size: 13px;
  font-weight: 500;
}

.lightTextRight_z7a0k {
  text-align: right;
  font-size: 13px;
  font-weight: 400;
  color: var(--595959-color);
}

.greenTag_N6vwt {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
}
.greenText_y97MK {
  font-size: 13px;
  font-weight: 500;
  color: var(--_16c098-color);
  -webkit-user-select: none;
          user-select: none;
}

.separator_GVhzv {
  width: 100%;
  height: 1px;
  background: var(--e3-border);
  min-height: 1px;
}

.validateContainer_cIIQL {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  background: var(--f5-background);
  padding: 0px 24px;
  height: 31px;
  min-height: 31px;
}

.validateInput_QwCfj {
  border: none;
  outline: none;
  font-size: 14px;
  color: var(--_71717a-color);
  background-color: transparent;
  font-weight: 400;
}
.validateInput_QwCfj::placeholder {
  color: var(--_71717a-color);
}

.validateInput_QwCfj::-webkit-inner-spin-button,
.validateInput_QwCfj::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.validateButton_ENXMM {
  font-size: 14px;
  font-weight: 600;
  color: var(--_2-color);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.upgradePlanButton_S13iI {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  background: var(--_2-color);
  border: none;
  outline: none;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  height: 44px;
  min-height: 44px;
  color: var(--white-background);
  font-size: 16px;
  font-weight: 500;
  z-index: 999999;
  strong {
    font-weight: 600;
  }
}

.currencyContainer_fs7rO {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--6d6d6d-color);
  font-size: 12px;
  font-weight: 400;
  gap: 4px;
  span {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    color: var(--622fae-color);
  }
}
.bottomText_jbN85 {
  width: 100%;
  margin-top: 5px;
  justify-self: center;
  max-width: 362px;
  color: var(--595959-color);
  font-size: 12px;
  font-weight: 400;
}

.link_D5OqV {
  text-decoration: underline;
  color: inherit;
  cursor: pointer;
}

.addPaymentMethod_AZMB_ {
  font-size: 14px;
  font-weight: 600;
  color: var(--_2-color);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  text-decoration: underline;
  margin-top: 5px;
}




.stripeContainerFlex_a2mNI {
  display: flex;
  gap: 4px;
  span {
    font-size: 13px;
    color: var(--8C90A2-color);
  }
  > div {
    flex: 1 1;
  }
}
.stripeContainerFlex_a2mNI > div {
  display: flex;
  gap: 10px;
  margin: 10px 0;
  flex-direction: column;
}

.stripeContainerFlex_a2mNI > div > div {
  flex: 1 1 100%; 
  padding: 6px;
  box-sizing: border-box;
  background-color: var(--f0-border);
}



.moreInfoContainer_qyEG6{
  background-color: var(--f5-background);
  transition: background-color 0.3s ease;
  border-radius: 999px;
  cursor: pointer;
}


.moreInfoContainer_qyEG6:hover {
stroke: var(--e0-border);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/UpgradePlan/UpgradePlan.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,qCAAqC;EACrC,6CAA6C;EAC7C,0CAA0C;EAC1C,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gDAA0C;EAC1C,gBAAgB;EAChB;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,WAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B;IACE;MACE,aAAa;IACf;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR;IACE,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,0BAA0B;EAC5B;AACF;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;;;;AAKA;EACE,aAAa;EACb,QAAQ;EACR;IACE,eAAe;IACf,0BAA0B;EAC5B;EACA;IACE,SAAO;EACT;AACF;AACA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;AACpC;;;;AAIA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,oBAAoB;EACpB,eAAe;AACjB;;;AAGA;AACA,wBAAwB;AACxB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.modalContainer {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--_00000020-background);\n  justify-content: center;\n  align-items: center;\n  z-index: 5;\n  transition: opacity 300ms ease-in-out;\n  -webkit-transition: opacity 300ms ease-in-out;\n  -moz-transition: opacity 300ms ease-in-out;\n  -ms-transition: opacity 300ms ease-in-out;\n  -o-transition: opacity 300ms ease-in-out;\n}\n.upgradePlanContainer {\n  background: var(--white-background);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  max-width: 780px;\n  max-height: 90vh;\n  transform: scale(1);\n  animation: scaleUp 300ms ease-out forwards;\n  overflow: hidden;\n  @media (width<=768px) {\n    max-width: 100vw;\n    width: 100vw;\n    height: 100vh;\n    max-height: 100vh;\n    border-radius: 0;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    -ms-border-radius: 0;\n    -o-border-radius: 0;\n  }\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n.upgradePlanHeader {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  height: 64px;\n  border-bottom: 1px solid var(--e3-border);\n  background: var(--f5-background);\n}\n.headerLeft {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: var(--_2-color);\n  font-size: 20px;\n  font-weight: 600;\n  gap: 10px;\n}\n.closeIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;  \n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--f6-background);\n  user-select: none;\n  text-decoration: underline;\n}\n.upgradePlanTitle {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--_2-color);\n  margin: 0px;\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n  max-height: 100vh;\n  flex-wrap: wrap;\n  overflow: hidden;\n  background: var(--f5-background);\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n.leftContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n  width: 60%;\n  padding: 10px 14px;\n  overflow-y: auto;\n  border-radius: 10px;\n  margin: 0px 8px 8px;\n  background: var(--white-background);\n  flex: 1.5;\n  min-width: 400px;\n  max-height: 70vh;\n  overflow-y: scroll;\n  h3 {\n    margin: 10px 0px;\n    font-size: 16px;\n  }\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.leftContainer input::placeholder {\n  color: var(--_75-color);\n}\n\n.leftContainer::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n.titleWithIcon {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n.leftContainer::-webkit-scrollbar-thumb {\n  background-color: var(--e2-background);\n  border-radius: 12px;\n}\n.leftContainer::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n\n.rightContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 40%;\n  padding: 10px 12px;\n  flex: 1;\n  overflow-y: auto;\n  min-width: 200px;\n}\n.rightContainer::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.rightContainer::-webkit-scrollbar-thumb {\n  background-color: var(--e2-background);\n  border-radius: 12px;\n}\n.rightContainer::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.lightText {\n  color: var(--595959-color);\n  line-height: 18px;\n  max-width: 362px;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.paymentMethodsContainer {\n  display: grid;\n  align-items: flex-start;\n  gap: 20px;\n  flex-direction: column;\n}\n.paymentMethodsContainerGrid {\n  grid-template-columns: 1fr 1fr;\n  > div:nth-child(1) {\n    > div {\n      display: flex;\n    }\n  }\n}\n\n.spacedBetween {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  color: var(--_2-color);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.lightTextRight {\n  text-align: right;\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--595959-color);\n}\n\n.greenTag {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 5px;\n}\n.greenText {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--_16c098-color);\n  user-select: none;\n}\n\n.separator {\n  width: 100%;\n  height: 1px;\n  background: var(--e3-border);\n  min-height: 1px;\n}\n\n.validateContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 6px;\n  background: var(--f5-background);\n  padding: 0px 24px;\n  height: 31px;\n  min-height: 31px;\n}\n\n.validateInput {\n  border: none;\n  outline: none;\n  font-size: 14px;\n  color: var(--_71717a-color);\n  background-color: transparent;\n  font-weight: 400;\n}\n.validateInput::placeholder {\n  color: var(--_71717a-color);\n}\n\n.validateInput::-webkit-inner-spin-button,\n.validateInput::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.validateButton {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--_2-color);\n  cursor: pointer;\n  user-select: none;\n}\n\n.upgradePlanButton {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 24px;\n  background: var(--_2-color);\n  border: none;\n  outline: none;\n  cursor: pointer;\n  user-select: none;\n  height: 44px;\n  min-height: 44px;\n  color: var(--white-background);\n  font-size: 16px;\n  font-weight: 500;\n  z-index: 999999;\n  strong {\n    font-weight: 600;\n  }\n}\n\n.currencyContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--6d6d6d-color);\n  font-size: 12px;\n  font-weight: 400;\n  gap: 4px;\n  span {\n    cursor: pointer;\n    user-select: none;\n    color: var(--622fae-color);\n  }\n}\n.bottomText {\n  width: 100%;\n  margin-top: 5px;\n  justify-self: center;\n  max-width: 362px;\n  color: var(--595959-color);\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.link {\n  text-decoration: underline;\n  color: inherit;\n  cursor: pointer;\n}\n\n.addPaymentMethod {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--_2-color);\n  cursor: pointer;\n  user-select: none;\n  text-decoration: underline;\n  margin-top: 5px;\n}\n\n\n\n\n.stripeContainerFlex {\n  display: flex;\n  gap: 4px;\n  span {\n    font-size: 13px;\n    color: var(--8C90A2-color);\n  }\n  > div {\n    flex: 1;\n  }\n}\n.stripeContainerFlex > div {\n  display: flex;\n  gap: 10px;\n  margin: 10px 0;\n  flex-direction: column;\n}\n\n.stripeContainerFlex > div > div {\n  flex: 1 1 100%; \n  padding: 6px;\n  box-sizing: border-box;\n  background-color: var(--f0-border);\n}\n\n\n\n.moreInfoContainer{\n  background-color: var(--f5-background);\n  transition: background-color 0.3s ease;\n  border-radius: 999px;\n  cursor: pointer;\n}\n\n\n.moreInfoContainer:hover {\nstroke: var(--e0-border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `modalContainer_bXm9V`,
	"upgradePlanContainer": `upgradePlanContainer_tPujG`,
	"scaleUp": `scaleUp_jx0lu`,
	"scaleDown": `scaleDown_SiOJT`,
	"fadeOut": `fadeOut_lEtme`,
	"upgradePlanHeader": `upgradePlanHeader_mTnqa`,
	"headerLeft": `headerLeft_Of7GH`,
	"closeIcon": `closeIcon_IVDfF`,
	"upgradePlanTitle": `upgradePlanTitle_PTgOD`,
	"content": `content_WUfDK`,
	"leftContainer": `leftContainer_dYRkJ`,
	"titleWithIcon": `titleWithIcon_zjcR8`,
	"rightContainer": `rightContainer_JwaxT`,
	"lightText": `lightText_d6Dvg`,
	"paymentMethodsContainer": `paymentMethodsContainer_zvwNA`,
	"paymentMethodsContainerGrid": `paymentMethodsContainerGrid_RRAI6`,
	"spacedBetween": `spacedBetween_gCdwa`,
	"lightTextRight": `lightTextRight_z7a0k`,
	"greenTag": `greenTag_N6vwt`,
	"greenText": `greenText_y97MK`,
	"separator": `separator_GVhzv`,
	"validateContainer": `validateContainer_cIIQL`,
	"validateInput": `validateInput_QwCfj`,
	"validateButton": `validateButton_ENXMM`,
	"upgradePlanButton": `upgradePlanButton_S13iI`,
	"currencyContainer": `currencyContainer_fs7rO`,
	"bottomText": `bottomText_jbN85`,
	"link": `link_D5OqV`,
	"addPaymentMethod": `addPaymentMethod_AZMB_`,
	"stripeContainerFlex": `stripeContainerFlex_a2mNI`,
	"moreInfoContainer": `moreInfoContainer_qyEG6`
};
export default ___CSS_LOADER_EXPORT___;
